import {
  CmpTypographyField,
  CmpTextField,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";

import moment from "moment";
export default function WmsHead({
  xref,
  vRdxHead,
  xErrorMsg,
  vRdxuserLoc,
  fLocation,
  fReferenceNo,
  fReferenceNo_Enter,
  fDate,
  PoTypeArr,
}) {
  return (
    <form id="WmsStockAdjustmentHead">
      <Grid
        container
        rowSpacing={{ xs: 4, sm: 0, md: 2 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        className="align-items-center"
      >
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Sheet No"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpTextField
            xTextAlign="center"
            xtabIndex={"1"}
            xValue={vRdxHead.SheetNo}
            xVariant={"standard"}
            xType={"text"} // text/number/password
            xName={"SheetNo"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsg.SheetNo === "" ? false : true}
            xErrorMessage={xErrorMsg.SheetNo}
          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Ref.No"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpTextField
            xref={xref}
            xtabIndex={"2"}
            xValue={vRdxHead.ReferenceNo}
            xType={"text"} // text/number/password
            xName={"ReferenceNo"}
            xReadOnly={true}
            xOnChange={fReferenceNo}
            xOnKeyUp={fReferenceNo_Enter}
            xError={xErrorMsg.ReferenceNo === "" ? false : true}
            xErrorMessage={xErrorMsg.ReferenceNo}
            xTextAlign="center"
          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"P.O Type"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpTextField
            xref={xref}
            xtabIndex={"3"}
            xValue={vRdxHead.POTypeName}
            xType={"text"} // text/number/password
            xName={"PoType"}
            xReadOnly={true}
            // xOnChange={""}
            // xOnKeyUp={""}
            xError={xErrorMsg.PoType === "" ? false : true}
            xErrorMessage={xErrorMsg.PoType}
            xTextAlign="center"
          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"P.O No"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpTextField
            xref={xref}
            xtabIndex={"4"}
            xValue={vRdxHead.PoNo}
            xType={"text"} // text/number/password
            xName={"PoNo"}
            xReadOnly={true}
            // xOnChange={""}
            // xOnKeyUp={""}
            xError={xErrorMsg.PoNo === "" ? false : true}
            xErrorMessage={xErrorMsg.PoNo}
            xTextAlign="center"
          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"PDTUserCd"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpTextField
            xref={xref}
            xtabIndex={"5"}
            xValue={vRdxHead.PDTUserCode}
            xType={"text"} // text/number/password
            xName={"PDTUserCode"}
            xReadOnly={true}
            // xOnChange={""}
            // xOnKeyUp={""}
            xError={xErrorMsg.PDTUserCode === "" ? false : true}
            xErrorMessage={xErrorMsg.PDTUserCode}
            xTextAlign="center"
          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"PDTUserCd"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpTextField
            xref={xref}
            xtabIndex={"6"}
            xValue={vRdxHead.PDTUserName}
            xType={"text"} // text/number/password
            xName={"PDTUserName"}
            xReadOnly={true}
            // xOnChange={""}
            // xOnKeyUp={""}
            xError={xErrorMsg.PDTUserName === "" ? false : true}
            xErrorMessage={xErrorMsg.PDTUserName}
            xTextAlign="center"
          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Location"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpTextField
            xref={xref}
            xtabIndex={"6"}
            xValue={vRdxHead.LocName}
            xType={"text"} // text/number/password
            xName={"LocName"}
            xReadOnly={true}
            // xOnChange={""}
            // xOnKeyUp={""}
            xError={xErrorMsg.LocName === "" ? false : true}
            xErrorMessage={xErrorMsg.LocName}
            xTextAlign="center"
          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Date"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpTextField
            xref={xref}
            xtabIndex={"6"}
            xValue={moment(vRdxHead.Date).format("DD/MM/YYYY")}
            xType={"text"} // text/number/password
            xName={"Date"}
            xReadOnly={true}
            // xOnChange={""}
            // xOnKeyUp={""}
            xError={xErrorMsg.Date === "" ? false : true}
            xErrorMessage={xErrorMsg.Date}
            xTextAlign="center"
          />
        </Grid>
        {/* <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Location"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpSelectBox
            xtabIndex={"7"}
            xLabelText="Location"
            xValue={vRdxHead.Loc}
            xOnChange={fLocation}
            xName={"Loc"}
            xData={vRdxuserLoc}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsg.Loc === "" ? false : true}
            xErrorMessage={xErrorMsg.Loc}
            xDisable={true}
          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"P.O Type"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpSelectBox
            xtabIndex={"7"}
            xLabelText=""
            xVariant={"standard"}
            xValue={vRdxHead.PoType}
            xOnChange={""}
            xName={"PoType"}
            xData={PoTypeArr}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsg.PoType === "" ? false : true}
            xErrorMessage={xErrorMsg.PoType}
            xDisable={true}
          />
        </Grid>

        <Grid item xs={3} sm={2} md={2} lg={2}>
          <CmpTypographyField xcomponent={"span"} xText={"Date"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={4}>
          <CmpDatePicker
            xDisable={true}
            xtabIndex={"8"}
            xLabelText={"Date"}
            xValue={vRdxHead.Date}
            xOnChange={fDate}
            xName={"Date"}
            xError={xErrorMsg.Date === "" ? false : true}
            xErrorMessage={xErrorMsg.Date}
          />
         
        </Grid> */}
      </Grid>
    </form>
  );
}
